import { useState, useEffect } from 'react';

export const useTheme = () => {
    const [theme, setTheme] = useState('light');

    useEffect(() => {
        // Detectar preferencia del sistema o localStorage
        const detectTheme = () => {
            const savedTheme = localStorage.getItem('landing-theme');
            if (savedTheme) {
                return savedTheme;
            }
            
            // Detectar preferencia del navegador
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                return 'dark';
            }
            
            return 'light';
        };

        const initialTheme = detectTheme();
        setTheme(initialTheme);
        loadTheme(initialTheme);
        
        // Escuchar cambios en la preferencia del sistema
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => {
            if (!localStorage.getItem('landing-theme')) {
                const newTheme = e.matches ? 'dark' : 'light';
                setTheme(newTheme);
                loadTheme(newTheme);
            }
        };

        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    const loadTheme = (themeName) => {
        const existingLink = document.getElementById('landing-theme');
        if (existingLink) {
            existingLink.remove();
        }
        
        const link = document.createElement('link');
        link.id = 'landing-theme';
        link.rel = 'stylesheet';
        link.href = `/themes/lara-${themeName}-wins/theme.css?t=${new Date().getTime()}`;
        document.head.appendChild(link);
        
        // Agregar clase al body para CSS específico del tema
        document.body.className = document.body.className.replace(/theme-\w+/g, '');
        document.body.classList.add(`theme-${themeName}`);
    };

    const toggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
        localStorage.setItem('landing-theme', newTheme);
        loadTheme(newTheme);
    };

    return {
        theme,
        toggleTheme,
        loadTheme
    };
};
